export enum BasecampEvents {
  IsLoaded = 'is_loaded',
  SessionExpired = 'session_expired',
}

export type BasecampMessage = {
  event: BasecampEvents;
};

export const IsLoadedMessage: BasecampMessage = {
  event: BasecampEvents.IsLoaded,
};

export const SessionExpiredMessage: BasecampMessage = {
  event: BasecampEvents.SessionExpired,
};
